import React from 'react'

import * as S from './styles'

/**
 * @typedef {Object} SwitchProps
 * @property {string} [ariaLabel]
 * @property {string} [name]
 * @property {boolean} [checked]
 * @property {React.ChangeEventHandler<HTMLInputElement>} [onChange]
 * @property {string} [id]
 */

/**
 * @param {SwitchProps} props
 */
export default function Switch({ ariaLabel, name, checked, onChange, id }) {
  return (
    <S.Switch
      id={id}
      aria-label={ariaLabel}
      name={name}
      size="md"
      checked={checked}
      onChange={onChange}
    />
  )
}
